import React, { useState, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "./pincity.css";
import logoimage from './assets/ajlogo2026.png';
mapboxgl.accessToken =
  "pk.eyJ1IjoiYWpqZXJ1c2FsZW0iLCJhIjoiY2l4b2t3N2lyMDAxMzJxcHMwZ3IzOWN1OSJ9.cxZW0ZgGPFDZpc_-JtRBxg";
// Cities list
const cities = [{"Category":"Qatar","name":"Where is Al Udeid airbase?","lat":25.116678,"lon":51.316369,"blurb":"Located 35km (22 miles) southwest of central Doha, Al Udeid is the primary hub for the Qatar Emiri Air Force and hosts the largest US military presence in the Middle East."},{"Category":"Qatar","name":"Where is Ras Laffan, the major LNG hub?","lat":25.918077,"lon":51.523183,"blurb":"Situated on the northeast coast of Qatar, roughly 80km (50 miles) north of Doha, Ras Laffan has the largest liquefied natural gas (LNG) production in the GCC."},{"Category":"Qatar","name":"Where is the national museum shaped like a desert‑rose crystal?","lat":25.288013,"lon":51.549467,"blurb":"Located along the Doha Corniche and opened in 2019, the National Museum of Qatar, designed by French architect Jean Nouvel, is shaped like a desert rose crystal, with interlocking discs creating its distinctive form."},{"Category":"Qatar","name":"Where was the FIFA World Cup 2022 final held?","lat":25.420726,"lon":51.490862,"blurb":"In 2022, Qatar became the first Arab country to host the FIFA World Cup. The final match took place in the city of Lusail on December 18, 2022."},{"Category":"Qatar","name":"Where is Hamad international airport?","lat":25.26584,"lon":51.611493,"blurb":"Located on the eastern edge of Qatar's capital, Doha, Hamad international airport opened in 2014 and has consistently been ranked among the world's top airports."},{"Category":"Bahrain","name":"Where is the 400-year-old \"Tree of Life\" located?","lat":25.994096,"lon":50.583054,"blurb":"Located in the southern desert of Bahrain, 40km (25 miles) from the capital, Manama, the 9.75-metre (32-foot) Ghaf tree has survived in the harsh desert environment and has come to symbolise endurance, resilience and life."},{"Category":"Bahrain","name":"Where is the Al-Fateh Grand Mosque located?","lat":26.218582,"lon":50.59825,"blurb":"Located in Bahrain's capital, Manama, the mosque is one of the largest in the world and is known for its massive fibreglass dome, the largest of its kind."},{"Category":"Bahrain","name":"Where is the headquarters of the US Navy's 5th Fleet?","lat":26.207949,"lon":50.612765,"blurb":"The headquarters of the largest US naval base in the region is located in Juffair, a district of Manama, Bahrain."},{"Category":"Bahrain","name":"Where is the GCC's only island nation?","lat":26.103406,"lon":50.546699,"blurb":"The Kingdom of Bahrain is an archipelago centred on the main Bahrain Island and is connected to mainland Saudi Arabia by the 25km (16-mile) King Fahd Causeway."},{"Category":"Kuwait","name":"Where is the longest bridge in the GCC?","lat":29.464388,"lon":47.990404,"blurb":"The Sheikh Jaber al‑Ahmad al‑Sabah Causeway spans the Bay of Kuwait, connecting Kuwait City with northern Kuwait. The 48.5km (30-mile) bridge was completed in 2019."},{"Category":"Kuwait","name":"Which country has the highest-valued currency unit in the world?","lat":29.36711635,"lon":47.55553652,"blurb":"The Kuwaiti dinar, introduced in 1961 to replace the Gulf rupee, is worth about $3.25."},{"Category":"Kuwait","name":"Which capital city records the highest peak summer temperatures?","lat":29.375216,"lon":47.973725,"blurb":"With summer highs frequently soaring above 50C (122F), Kuwait City consistently ranks as the hottest capital on Earth, pushing the limits of urban habitability."},{"Category":"Kuwait","name":"Where is al-Qasr al-Ahmar, or the Red Palace?","lat":29.348092,"lon":47.679954,"blurb":"Located in Al Jahra, 32km (20 miles) west of Kuwait City, the mud‑brick fortress is famous as the site of the Battle of Jahra in 1920 and now functions as a national museum and cultural centre."},{"Category":"Oman","name":"Where is the ancient city of Qalhat located?","lat":22.701159,"lon":59.370851,"blurb":"Located on Oman's east coast, the ancient walled city of Qalhat is a UNESCO World Heritage Site and served as a major port and the second capital of the Kingdom of Hormuz between the 11th and 15th centuries."},{"Category":"Oman","name":"Where is the Sultan Qaboos Grand Mosque located?","lat":23.582903,"lon":58.388261,"blurb":"Oman's largest mosque, located in the Bousher district of the capital Muscat, was completed in 2001 and can accommodate 20,000 worshippers. The prayer hall is home to a world-famous hand-loomed Persian carpet."},{"Category":"Oman","name":"Where is the desert oasis Wadi Bani Khalid found?","lat":22.592423,"lon":59.089494,"blurb":"Wadi Bani Khalid is a desert oasis in Oman's Ash Sharqiyah region, located about 200km (125 miles) from Muscat. It features deep turquoise pools present throughout the year, date palms, and vast rocky cliffs."},{"Category":"Oman","name":"Where is the Strait of Hormuz?","lat":26.654429,"lon":56.451173,"blurb":"Located between Iran and Oman, connecting the Gulf to the Arabian Sea, the narrow waterway is the sole maritime exit for several Gulf exporters, and in peacetime, 20 percent of the world's oil and gas supplies pass through it."},{"Category":"Oman","name":"Which coastal city turns green each summer from a unique monsoon?","lat":17.009906,"lon":54.107377,"blurb":"Salalah, located in the southern Dhofar region of Oman, experiences the kharif season from late June to early September, when moist Indian Ocean winds bring mist and drizzle that transform the landscape."},{"Category":"Saudi","name":"Where do millions of Muslims perform the annual Hajj?","lat":21.422472,"lon":39.826188,"blurb":"The annual Hajj pilgrimage takes place in Mecca, in the western part of Saudi Arabia, about 80km (50 miles) inland from the Red Sea coast."},{"Category":"Saudi","name":"Where is the port city of Yanbu?","lat":24.084224,"lon":38.061568,"blurb":"Yanbu is a port city on Saudi Arabia's Red Sea coast. It marks the western end of the East-West Pipeline, a 1,200km (750-mile) crude oil pipeline running from eastern Saudi Arabia to the Red Sea that bypasses the Strait of Hormuz."},{"Category":"Saudi","name":"Where is the headquarters of the biggest oil company in the world?","lat":26.308668,"lon":50.128571,"blurb":"Saudi Aramco is located in Dhahran, in eastern Saudi Arabia. For every 10 barrels of oil produced globally, 1 barrel comes specifically from Saudi Aramco."},{"Category":"Saudi","name":"Where is al-Masjid an-Nabawi, the mosque where Prophet Muhammad is buried?","lat":24.468589,"lon":39.610577,"blurb":"Located in the heart of Medina in western Saudi Arabia is the second-holiest site in Islam after the Great Mosque in Mecca. It is about 340km (210 miles) from Mecca by road."},{"Category":"Saudi","name":"Which GCC city has the highest population?","lat":24.717093,"lon":46.67992,"blurb":"Riyadh, the capital of Saudi Arabia, is located on the vast Najd plateau in the centre of the country, about 850km (530 miles) from Mecca in the west. The city has a population of approximately 8.1 million."},{"Category":"UAE","name":"Where is Qasr Al Hosn, also known as the White Fort?","lat":24.4819707,"lon":54.3540331,"blurb":"Known as the White Fort, Qasr Al Hosn is the oldest standing structure in Abu Dhabi. Its Inner Fort, expanded in 1795 from an 18th-century watchtower, served as the official seat of government for the ruling Al Nahyan family."},{"Category":"UAE","name":"Where is the world's largest man-made harbour, the Port of Jebel Ali, located?","lat":25.00052,"lon":55.059613,"blurb":"The Port of Jebel Ali in Dubai, UAE, is the world's largest man‑made harbour and the Middle East's busiest port. It handles millions of containers each year and connects trade routes between East and West."},{"Category":"UAE","name":"Where is the world's tallest building located?","lat":25.196493,"lon":55.273804,"blurb":"The Burj Khalifa in Dubai, UAE, is the tallest building in the world. It opened in 2010 and stands 828 metres (2,717 feet) tall with 163 usable floors."},{"Category":"UAE","name":"Where is the world's busiest airport for international passengers?","lat":25.247117,"lon":55.362838,"blurb":"Dubai international airport is the world's busiest airport for international passengers, handling 95.2 million international travellers in 2025."},{"Category":"UAE","name":"Where is the first nuclear power station in the Arab world?","lat":23.964164,"lon":52.241621,"blurb":"The Barakah Nuclear Energy Plant is located in the Al Dhafra region of Abu Dhabi, UAE. First connected in 2020, it now provides roughly a quarter of the UAE's total electricity needs."}];


// Shuffle helper
// function shuffleArray(array) {
//   return [...array].sort(() => Math.random() - 0.5);
// }

function shuffleArray(array) {
  const result = [...array];

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}

function getRandomCities(cities, total = 10) {
  const byCountry = {};


  cities.forEach(c => {
    (byCountry[c.Category] ||= []).push(c);
  });

  const picked = Object.values(byCountry).map(
    group => group[Math.floor(Math.random() * group.length)]
  );

  const remaining = cities.filter(c => !picked.includes(c));
  const extra = shuffleArray(remaining).slice(0, total - picked.length);

  return shuffleArray([...picked, ...extra]);
}

// Haversine function
function haversine(lat1, lon1, lat2, lon2) {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const R = 6371; // Earth radius in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export default function PinTheCity() {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const markerRefs = useRef([]);

  // const [shuffledCities, setShuffledCities] = useState(() => {
  //   // Select a random 10 cities
  //   return shuffleArray(cities).slice(0, 10);
  // });


  const [shuffledCities, setShuffledCities] = useState(() =>
  getRandomCities(cities, 10)
);


  const [cityIndex, setCityIndex] = useState(0);
  const [guess, setGuess] = useState(null);
  const [score, setScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [revealed, setRevealed] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [showFinalScoreButton, setShowFinalScoreButton] = useState(false);

  const [closestCity, setClosestCity] = useState(null);
  const [minDistance, setMinDistance] = useState(null);

  const city = shuffledCities[cityIndex];
  const correct = { lat: city.lat, lon: city.lon };

  // Calculate progress percentage
  const progress = (totalScore/100)*100;


  // Function to determine zoom level based on screen size
function getZoomLevel() {
    const width = window.innerWidth; // Get the width of the window
    if (width <= 480) return 3.5; // Mobile devices
    if (width > 480 && width <= 768) return 4; // Tablets
    if (width > 768 && width <= 1120) return 4.5; // Tablets
    return 5; // Desktops
}

const mymapBounds = [
    [2.842563, -5.180569],  // Southwest: Near the border with Iraq/Turkey & Persian Gulf
    [80.740717, 44.456602] // Northeast: Near the border with Turkmenistan/Afghanistan
];
  
  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/ajjerusalem/cmo02n3lp00ad01sbdzbj4o70",
        // style:"mapbox://styles/ajjerusalem/clqwcrr61010201qud2ln7vck",
        center: [47.127971, 23.919397],
        zoom: getZoomLevel(), // Set zoom level based on screen size
        minZoom: 3.2,
        maxZoom: 6.5,
        interactive: true,
        maxBounds:mymapBounds
      });

      mapRef.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

      
      mapRef.current.on("click", (e) => {
        if (!revealed) {
          const { lng, lat } = e.lngLat;
          let closest = null;
          let minDist = Infinity;

          cities.forEach((city) => {
            const distance = haversine(lat, lng, city.lat, city.lon);
            if (distance < minDist) {
              minDist = distance;
              closest = city;
            }
          });

          setClosestCity(closest);
          setMinDistance(minDist);
          setGuess({ lat, lon: lng });
        }
      });

      // mapRef.current.on("load", () => {
      //   mapRef.current.addSource("my-image", {
      //     type: "image",
      //     url: process.env.PUBLIC_URL + "/mapo.png",
      //     coordinates: [
      //       [34.2, 33.3],
      //       [35.7, 33.3],
      //       [35.7, 29.477],
      //       [34.2, 29.477],
      //     ],
      //   });

      //   mapRef.current.addLayer({
      //     id: "image-layer",
      //     type: "raster",
      //     source: "my-image",
      //     paint: { "raster-opacity": 1 },
      //   });
      // });
      mapRef.current.getCanvas().style.cursor = 'default';

      mapRef.current.on('mouseleave', () => {
        mapRef.current.getCanvas().style.cursor = 'default'; // Reset to normal cursor
      });
    }
  }, [revealed]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    markerRefs.current.forEach((marker) => marker.remove());
    markerRefs.current = [];

    if (guess) {
      const guessMarker = new mapboxgl.Marker({ color: "red" })
        .setLngLat([guess.lon, guess.lat])
        .addTo(map);
      markerRefs.current.push(guessMarker);
    }

    if (revealed) {
      const correctMarker = new mapboxgl.Marker({ color: "green" })
        .setLngLat([correct.lon, correct.lat])
        .addTo(map);
      markerRefs.current.push(correctMarker);
    }
  }, [guess, revealed]);

  const revealAnswer = () => {
    if (!guess) return;
    const distance = haversine(guess.lat, guess.lon, correct.lat, correct.lon);
    let roundScore = 0;
    if (distance < 70) roundScore = 10;
    else if (distance < 90) roundScore = 9;
    else if (distance < 110) roundScore = 8;
    else if (distance < 140) roundScore = 7;
    else if (distance < 175) roundScore = 6;
    else if (distance < 220) roundScore = 5;
    else if (distance < 275) roundScore = 4;
    else if (distance < 320) roundScore = 3;
    else if (distance < 450) roundScore = 2;
    else if (distance < 550) roundScore = 1;
    else roundScore = 0;

    setTotalScore((prev) => prev + roundScore);
    setScore(roundScore);
    setRevealed(true);
  
    if (cityIndex === shuffledCities.length - 1) {
      setShowFinalScoreButton(true); // Prepare to show final score
    }
  };

  const nextRound = () => {
    const nextIndex = cityIndex + 1;

    if (nextIndex >= shuffledCities.length) {
      setGameOver(true);
    } else {
      setCityIndex(nextIndex);
      setGuess(null);
      setRevealed(false);
    }
  };

  const restartGame = () => {
    setShuffledCities(shuffleArray(cities).slice(0, 10));  // Limit to 10 cities again
    setGameOver(false);
    setCityIndex(0);
    setTotalScore(0);
    setScore(0);
    setGuess(null);
    setRevealed(false);
  };


  const tweetText = `How well do you know the GCC? I scored ${totalScore}/100. @AJEnglish @AJLabs - play here: https://aljazeera.com/gccquiz`;
  const whatsText= `How well do you know the GCC? I scored ${totalScore}/100. @AJEnglish @AJLabs — play here: https://aljazeera.com/gccquiz`;
  const tweeturl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
  const whatsurl = `whatsapp://send?text=${encodeURIComponent(whatsText)}`;

  return (
    <div className=" relative w-full h-screen flex flex-col items-center p-4">



<div className="centerbarx flex flex-col items-center">
<div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
  {

    <a href="https://aljazeera.com" target="_blank" rel="noopener noreferrer">
      <img
        src={logoimage}
        alt="Al Jazeera"
        style={{ width: "94px", height:"auto" }}
      />
    </a>
    
  }
  </div>
</div> 

{/* Progress Bar + Counter */}
<div className="rightbarx flex flex-col items-center">
  {/* Counter Text */}
  <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
    Score: {totalScore}/100
  </div>

  {/* Progress Bar */}
  {/* <div className="rightbar w-3 bg-gray-300 rounded-lg overflow-hidden">
    <div
      className="bg-blue-500 w-full transition-all duration-300"
      style={{ height: `${progress}%` }}
    ></div>
  </div> */}
</div>



<div className="leftbarx flex flex-col items-center">
  {/* Counter Text */}
  <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
    Question: {cityIndex+1}/{shuffledCities.length}
  </div>
</div>

      {/* Main Content */}
      <p className="text-center whereis font-bold mb-2">
      </p>
      <p className="text-center cityguess">{city.name}</p>
      <p className="text-guess pad-bottom text-center font-bold mb-2">
        Drop a pin 📍 on the map 🌍 to guess
      </p>

      <div
        ref={mapContainer}
        style={{ height: "80vh", width: "100%" }}
        className="mb-4"
      />
      {/* Move the submit button right under the city name */}
      {!revealed && (
          
        <div className="submitbutton text-center mb-4">
               <div> <p className="text-guess pad-bottom text-center font-bold mb-2">
        Drop a pin 📍 on the map 🌍 to guess
      </p>
          <button
            className="buttonguess mt-2 px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
            onClick={revealAnswer}
            disabled={!guess}
          >
            Submit guess
          </button>
        </div>
        </div>
      )}


      {revealed && (
        <div className="popupbox inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="popupin bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-center">
          {!gameOver ? (
            <div><p className="text-lg strong mb-2">
              Your guess is{" "}
              {Math.round(
                haversine(guess.lat, guess.lon, correct.lat, correct.lon)
                ).toLocaleString()} km
              (
              {Math.round(
                haversine(guess.lat, guess.lon, correct.lat, correct.lon) / 1.61
                ).toLocaleString()} 
              {" "} miles away)
        {/* from {city.name}  */}
        {/* {closestCity && closestCity.name !== city.name && minDistance !== null && (
                <span className="mt-4 text-sm text-gray-700">, but only {Math.round(minDistance)}km from {closestCity.name}</span>
            )} */}
      </p>
      <p className="mb-1 score-text">You scored {score} points!</p>
          
          <p className="blurbtext">{city.blurb}</p>
          </div>
                ) : (<div></div>)}

            {gameOver ? (
              <div>
                <h2 className="text-xl font-semibold mb-2">Game Over!</h2>
                <p className="mb-4 totalscore">Your total score is: {totalScore}/100</p>

                <p>SHARE YOUR SCORE</p>
                <section className="combined-share__links text-center">
            
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Faljazeera.com%2Fgccquiz%2F">
                            <svg className="icon icon--facebook icon--social icon--24 " viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>facebook</title><path className="icon-main-color" d="M10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.65685547,19.1283203 8.4375,19.8785157 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042967,3.90625 12.2146484,3.90625 C13.3087305,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499023,6.5625 11.5625,7.33333984 11.5625,8.12416016 L11.5625,10 L14.3359375,10 L13.8925782,12.890625 L11.5625,12.890625 L11.5625,19.8785157 C16.3431445,19.1283203 20,14.9912891 20,10 C20,4.47714844 15.5228516,0 10,0 Z"></path></svg>
                          </a>
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter" href={tweeturl}>
                            <svg className="icon icon--twitter icon--social icon--24 " viewBox="0 0 26 24" version="1.1" aria-hidden="true"><title>twitter</title><path className="icon-main-color" fillRule="evenodd" d="m.063 0 10.039 13.237L0 24h2.273l8.845-9.423L18.263 24H26L15.397 10.018 24.799 0h-2.273l-8.145 8.678L7.801 0H.062Zm3.344 1.652H6.96l15.695 20.696h-3.554L3.407 1.652Z"></path></svg>
                          </a>
                          <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Whatsapp" href={whatsurl}>
                            <svg className="icon icon--whatsapp icon--social icon--24 " viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>whatsapp</title><path className="icon-main-color" d="M19 9.74a9.54 9.54 0 0 1-9.33 9.74 9 9 0 0 1-4.51-1.21L0 20l1.68-5.23a10 10 0 0 1-1.33-5A9.53 9.53 0 0 1 9.62 0 9.54 9.54 0 0 1 19 9.74zM14.33 12c-.05-.1-.21-.16-.44-.28s-1.35-.7-1.56-.78-.36-.12-.51.12a11.45 11.45 0 0 1-.73.94c-.13.16-.26.18-.49.06a6.28 6.28 0 0 1-1.84-1.19 7 7 0 0 1-1.27-1.66.35.35 0 0 1 .1-.49c.1-.11.23-.28.34-.42a1.6 1.6 0 0 0 .23-.4.42.42 0 0 0 0-.41c-.06-.12-.51-1.3-.7-1.78s-.39-.4-.52-.4H6.5a.83.83 0 0 0-.61.3 2.74 2.74 0 0 0-.8 2A4.63 4.63 0 0 0 6 10.05a9.54 9.54 0 0 0 3.9 3.61c2.33 1 2.33.64 2.75.6a2.33 2.33 0 0 0 1.54-1.14 2 2 0 0 0 .14-1.12z"></path></svg>
                          </a>

                        </section>
                <button
                  className="buttonguess px-4 py-2 bg-blue-600 text-white rounded"
                  onClick={restartGame}
                >
                  PLAY AGAIN
                </button>
              </div>
            ) : (
              <button
                className="buttonguess padit px-4 py-2 bg-green-600 text-white rounded"
                onClick={nextRound}
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
